<template>
    <div class="main-container" id="how-it-works">
        <span class="how-it-works">How it Works?</span>
        <div class="why-choose-us">
            <div class="content">
                <div class="blue-silhouette"></div>
                <div class="sign-up">
                    <span class="sign-up-1">Sign up </span><span class="create-your-account">Create your account and
                        start exploring our services in just a few
                        easy steps.</span>
                </div>
            </div>
            <div class="box-2">
                <div class="morphis-shield"></div>
                <div class="complete-kyc">
                    <span class="complete-kyc-2">Complete KYC </span><span class="verify-identity">Verify your identity
                        for added security and to unlock full trading
                        capabilities.</span>
                </div>
            </div>
            <div class="group-2">
                <div class="morphis-blue-up-arrow"></div>
                <div class="trade-section">
                    <span class="trade">Trade </span><span class="begin-trading">Begin trading securely and conveniently
                        once your KYC is
                        complete.</span>
                </div>
            </div>
            <div class="line"></div>
            <div class="line-3"></div>
        </div>
        <AbanButton :size="'small'" :type="'link'" :to="{ name: 'Sign Up', params: { selectedMethod: 'phone-number' } }"
            class="button">
            <span class="label">Sign Up Now</span>
            <div class="arrow-right-icon">
                <div class="vector"></div>
            </div>
        </AbanButton>
    </div>
</template>

<script>
import AbanButton from '../buttons/AbanButton.vue'

export default {
    name: 'HowItWorks',
    components: {
        AbanButton
    }
}
</script>

<style scoped>
.main-container {
    overflow: hidden;
}

.main-container,
.main-container * {
    box-sizing: border-box;
}

input,
select,
textarea,
button {
    outline: 0;
}

.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
    gap: calc(40 * var(--rpx));
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: calc(36 * var(--rpx)) calc(32 * var(--rpx)) calc(36 * var(--rpx)) calc(32 * var(--rpx));
    background: #ffffff;
}

.how-it-works {
    align-self: stretch;
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    height: calc(32 * var(--rpx));
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(24 * var(--rpx));
    font-weight: 700;
    line-height: calc(32 * var(--rpx));
    text-align: center;
    white-space: nowrap;
}

.why-choose-us {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(61 * var(--rpx));
    position: relative;
    z-index: 1;
}

.content {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(12 * var(--rpx));
    position: relative;
    padding: calc(16 * var(--rpx)) calc(12 * var(--rpx)) calc(16 * var(--rpx)) calc(12 * var(--rpx));
    z-index: 2;
    border-radius: calc(16 * var(--rpx));
}

.blue-silhouette {
    flex-shrink: 0;
    position: relative;
    width: calc(53 * var(--rpx));
    height: calc(60 * var(--rpx));
    background: url(@/assets/banners/SignUp.png) no-repeat center;
    background-size: cover;
    z-index: 3;
    overflow: hidden;
}

.sign-up {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    position: relative;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
    z-index: 4;
}

.sign-up-1 {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.create-your-account {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(14 * var(--rpx));
    font-weight: 400;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.box-2 {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(12 * var(--rpx));
    position: relative;
    padding: calc(16 * var(--rpx)) calc(12 * var(--rpx)) calc(16 * var(--rpx)) calc(12 * var(--rpx));
    z-index: 5;
    border-radius: calc(16 * var(--rpx));
}

.morphis-shield {
    flex-shrink: 0;
    position: relative;
    width: calc(53.10292434692383 * var(--rpx));
    height: calc(60 * var(--rpx));
    background: url(@/assets/banners/CompleteKyc.png) no-repeat center;
    background-size: cover;
    z-index: 6;
    overflow: hidden;
}

.complete-kyc {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    position: relative;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
    z-index: 7;
}

.complete-kyc-2 {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.verify-identity {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(14 * var(--rpx));
    font-weight: 400;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.group-2 {
    display: flex;
    align-items: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(12 * var(--rpx));
    position: relative;
    padding: calc(16 * var(--rpx)) calc(12 * var(--rpx)) calc(16 * var(--rpx)) calc(12 * var(--rpx));
    z-index: 8;
    border-radius: calc(16 * var(--rpx));
}

.morphis-blue-up-arrow {
    flex-shrink: 0;
    position: relative;
    width: calc(53 * var(--rpx));
    height: calc(60 * var(--rpx));
    background: url(@/assets/banners/Trade.png) no-repeat center;
    background-size: cover;
    z-index: 9;
    overflow: hidden;
}

.trade-section {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    position: relative;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
    z-index: 10;
}

.trade {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 500;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.begin-trading {
    position: relative;
    color: #0e2546;
    font-family: dana, var(--default-font-family);
    font-size: calc(14 * var(--rpx));
    font-weight: 400;
    line-height: calc(20 * var(--rpx));
    text-align: left;
}

.line {
    flex-shrink: 0;
    position: absolute;
    width: calc(1 * var(--rpx));
    height: calc(57 * var(--rpx));
    top: calc(94 * var(--rpx));
    left: calc(38 * var(--rpx));
    background: url(@/assets/banners/VerticalLine.png) no-repeat center;
    background-size: cover;
    z-index: 11;
}

.line-3 {
    flex-shrink: 0;
    position: absolute;
    width: calc(1 * var(--rpx));
    height: calc(57 * var(--rpx));
    top: calc(247 * var(--rpx));
    left: calc(38 * var(--rpx));
    background: url(@/assets/banners/VerticalLine.png) no-repeat center;
    background-size: cover;
    z-index: 12;
}

.button {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    gap: calc(12 * var(--rpx));
    position: relative;
    height: calc(56 * var(--rpx));
    min-height: calc(56 * var(--rpx));
    padding: calc(14 * var(--rpx)) calc(20 * var(--rpx)) calc(14 * var(--rpx)) calc(28 * var(--rpx));
    cursor: pointer;
    background: #3483f7;
    border: none;
    z-index: 13;
    max-height: calc(56 * var(--rpx));
    border-radius: calc(8 * var(--rpx));
    box-shadow: 0 calc(2 * var(--rpx)) calc(5.199999809265137 * var(--rpx)) 0 rgba(41, 92, 167, 0.24);
}

.label {
    flex-shrink: 0;
    flex-basis: auto;
    position: relative;
    height: calc(20 * var(--rpx));
    color: #ffffff;
    font-family: dana, var(--default-font-family);
    font-size: calc(16 * var(--rpx));
    font-weight: 600;
    line-height: calc(20 * var(--rpx));
    text-align: left;
    white-space: nowrap;
    z-index: 14;
}

.arrow-right-icon {
    flex-shrink: 0;
    position: relative;
    width: calc(24 * var(--rpx));
    height: calc(24 * var(--rpx));
    z-index: 15;
    overflow: hidden;
}

.vector {
    width: 1.5rem;
    position: relative;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
    background: url(@/assets/icons/arrow.svg) no-repeat center;
    background-size: 100% 100%;
}
</style>